// 0_global/shop_map.js
// Shop identity by Shoptet projectId. Does not touch window.NAT.lang —
// clone stays "cs" for translations.
//
// Usage:
//   import { byShop, getShopKey } from "../0_global/shop_map";
//   const value = byShop({ cs: …, sk: …, pl: … });
//   if (getShopKey() === "cs_clone") { … }

export const SHOPS = {
	cs: { projectId: 255255, lang: "cs" },
	cs_clone: { projectId: 696098, lang: "cs", fallback: "cs" },
	sk: { projectId: 453094, lang: "sk" },
	pl: { projectId: 684159, lang: "pl" },
};

const BY_PROJECT_ID = Object.fromEntries(Object.entries(SHOPS).map(([key, shop]) => [shop.projectId, key]));

export function getProjectId() {
	return Number(window.dataLayer?.[0]?.shoptet?.projectId) || 0;
}

export function getShopKey() {
	const known = BY_PROJECT_ID[getProjectId()];
	if (known) return known;
	const lang = window.dataLayer?.[0]?.shoptet?.language || window.NAT?.lang || "cs";
	const match = Object.entries(SHOPS).find(([, shop]) => shop.lang === lang && !shop.fallback);
	return match?.[0] || "cs";
}

export function getShop() {
	return SHOPS[getShopKey()];
}

export function getShopLang() {
	return getShop()?.lang || "cs";
}

export function byShop(map) {
	if (!map) return undefined;
	const key = getShopKey();
	if (map[key] !== undefined) return map[key];
	const fallback = SHOPS[key]?.fallback;
	if (fallback && map[fallback] !== undefined) return map[fallback];
	return map.cs;
}
